import { useEffect, useRef, useState } from 'react'

import {
  Navbar,
  NavbarItem,
  NavbarSection,
  NavbarSpacer,
} from '@/components/base/navbar'
import {
  Sidebar,
  SidebarBody,
  SidebarFooter,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from '@/components/base/sidebar'
import { SidebarLayout } from '@/components/base/sidebar-layout'
import {
  CalendarIcon,
  DocumentIcon,
  HomeIcon,
  InboxIcon,
  MagnifyingGlassIcon,
  UsersIcon,
} from '@heroicons/react/24/solid'
import { Outlet, useNavigation } from 'react-router'
import { GridLoader } from 'react-spinners'

export const Layout = () => {
  const [showLoading, setShowLoading] = useState(false)
  const navigation = useNavigation()

  const loadingTimer = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    if (navigation.state === 'loading') {
      loadingTimer.current = setTimeout(() => { setShowLoading(true) }, 500)
    } else {
      if (loadingTimer.current) clearTimeout(loadingTimer.current)
    }
  }, [navigation.state])

  return (
    <SidebarLayout
      navbar={
        <Navbar>
          <NavbarSpacer />
          <NavbarSection>
            <NavbarItem aria-label="Search" href="/search">
              <MagnifyingGlassIcon />
            </NavbarItem>
            <NavbarItem aria-label="Inbox" href="/inbox">
              <InboxIcon />
            </NavbarItem>
            { /* <ProfileDropdown position="navbar" /> */ }
          </NavbarSection>
        </Navbar>
      }
      sidebar={
        <Sidebar>
          <SidebarBody>
            <SidebarSection>
              <SidebarItem href="/">
                <HomeIcon />
                <SidebarLabel>Home</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/devices">
                <DocumentIcon />
                <SidebarLabel>Devices</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/integrations">
                <DocumentIcon />
                <SidebarLabel>Integrations</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/equipment">
                <UsersIcon />
                <SidebarLabel>Equipment</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/tests">
                <CalendarIcon />
                <SidebarLabel>Tests</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/item_types">
                <UsersIcon />
                <SidebarLabel>Item types</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/items">
                <CalendarIcon />
                <SidebarLabel>Items</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSpacer />
          </SidebarBody>
          <SidebarFooter className="max-lg:hidden">
            { /* <ProfileDropdown position="sidebar" /> */ }
          </SidebarFooter>
        </Sidebar>
      }
    >
      <Outlet />
      <div className={ `transition duration-500 fixed bottom-12 right-12 ${showLoading ? 'opacity-100' : 'opacity-0'}` }>
        <div className="w-full flex flex-row justify-center">
          <GridLoader color="lightgray" size={ 12 } />
        </div>
      </div>
    </SidebarLayout>
  )
}
